import { X } from "lucide-react";
import { createPortal } from "react-dom";

export default function Modal({ open, onClose, title, children, testid }) {
  if (!open) return null;
  // Portal to <body> so the fixed overlay escapes any transformed/animated
  // ancestor (e.g. .animate-fadeup) that would otherwise scope position:fixed
  // and push the modal into page flow (iOS/iPad: "must scroll down to find it").
  return createPortal(
    <div className="fixed inset-0 z-[60] flex items-start sm:items-center justify-center bg-black/40 p-3 sm:p-4 overflow-y-auto" onClick={onClose}>
      <div data-testid={testid} onClick={(e) => e.stopPropagation()} style={{ maxHeight: "88dvh" }}
        className="bg-white border-2 border-[#0A0A0A] w-full sm:max-w-md rounded-xl nb-shadow my-4 animate-fadeup max-h-[88vh] flex flex-col">
        <div className="flex items-center justify-between px-5 py-4 border-b-2 border-[#0A0A0A] shrink-0">
          <h3 className="font-display font-extrabold text-lg">{title}</h3>
          <button data-testid="modal-close" onClick={onClose} className="w-8 h-8 border-2 border-[#0A0A0A] rounded-lg flex items-center justify-center hover:bg-[#FAF9F6]">
            <X className="w-4 h-4" strokeWidth={2.5} />
          </button>
        </div>
        <div data-testid="modal-body" className="p-5 flex-1 min-h-0 overflow-y-auto overscroll-contain" style={{ WebkitOverflowScrolling: "touch" }}>{children}</div>
      </div>
    </div>,
    document.body
  );
}

export const Field = ({ label, children }) => (
  <div className="mb-3">
    <label className="label-tag block mb-1.5">{label}</label>
    {children}
  </div>
);
